import { dateAndTimeToMoment } from 'utils/dateTime';

export function validateMessages(t) {
  return {
    required: t('validateMessage:required'),
    types: {
      email: t('validateMessage:email'),
      number: t('validateMessage:number')
    },
    number: {
      range: t('validateMessage:range')
    }
  };
}

export function organisationNumberValidation(t) {
  return async (rules, value) => {
    const regex = '^[0-9]{10}$';
    if (!value && rules.required) {
      return Promise.reject(validateMessages(t).required);
    } else if (value && !value.match(regex)) {
      return Promise.reject(t('validateMessage:orgRegexMismatch'));
    } else if (value && !isValidLuhn(value)) {
      return Promise.reject(t('validateMessage:invalidOrgNumber'));
    } else {
      return Promise.resolve();
    }
  };
}

export function socialSecurityNumberValidation(t) {
  return async (rules, value) => {
    const regex = '^[0-9]{10}$';
    if (!value && rules.required) {
      return Promise.reject(validateMessages(t).required);
    } else if (value && !value.match(regex)) {
      return Promise.reject(t('validateMessage:socSecurityNrRegexMisMatch'));
    } else if (value && !isValidLuhn(value)) {
      return Promise.reject(t('validateMessage:invalidSocSecurityNr'));
    } else {
      return Promise.resolve();
    }
  };
}

export const isValidLuhn = pnr => {
  let number;
  let checksum = 0;
  for (let i = pnr.length - 1; i >= 0; i--) {
    number = parseInt(pnr.charAt(i));
    if (i % 2 === 1) {
      checksum += number;
    } else {
      checksum += number * 2 > 9 ? number * 2 - 9 : number * 2;
    }
  }
  return checksum % 10 === 0;
};

export function startAndStopTimeValidation(t, dateFrom, startTime, endTime) {
  return async (rules, dateTo) => {
    let startMoment = dateAndTimeToMoment(dateFrom, startTime);
    let stopMoment = dateAndTimeToMoment(dateTo, endTime);
    if (!dateTo && rules.required) {
      return Promise.reject(validateMessages(t).required);
    } else if (startMoment && startMoment.isAfter(stopMoment)) {
      return Promise.reject(t('validateMessage:startTimeBeforeStopTime'));
    } else {
      return Promise.resolve();
    }
  };
}
